module.exports = __webpack_public_path__ + "0a2e67413cb62a6ebb14958386b09059.webp";